import React from 'react';

const Button = ({
  text,
  icon,
  onClick,
  iconColor = 'text-black', // Default icon color
  type = 'button',
  disabled = false,
  className = '',
  'data-testid': dataTestId,
}) => {
  // Extract text color from className if present, otherwise default to white
  const textColorMatch = className.match(/text-(black|white|gray-\d+|orange|green|red|error-red)/);
  const textColorClass = textColorMatch ? textColorMatch[0] : 'text-white';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
      className={`flex items-center justify-center gap-2 font-bold py-2 px-4 rounded focus:outline-none focus:ring-0 ${className} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {icon && <span className={`${iconColor} flex`}>{icon}</span>}
      {text && <span className={textColorClass}>{text}</span>}
    </button>
  );
};

export default Button;
